module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Podrobný výpis hovorů")]), _vm._v(" "), _vm._l((_vm.linkList), function(link) {
    return _c('div', {
      key: link.year + link.month,
      staticClass: "cdr-link-button"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('a', {
      staticClass: "btn btn-info",
      class: {
        'disabled': !link.enabled
      },
      attrs: {
        "href": link.enabled ? ('/api/ipexcdrfiles/' + _vm.number + '-' + link.year + '-' + link.month + '.html') : false
      }
    }, [_vm._v("\n            " + _vm._s(_vm.czech_month_name(link.month)) + " " + _vm._s(link.year) + "\n          ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info dropdown-toggle dropdown-toggle-split",
      attrs: {
        "type": "button",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false",
        "disabled": !link.enabled
      }
    }, [_c('span', {
      staticClass: "sr-only"
    }, [_vm._v("Toggle Dropdown")])]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu"
    }, [_c('a', {
      staticClass: "dropdown-item",
      attrs: {
        "href": '/api/ipexcdrfiles/' + _vm.number + '-' + link.year + '-' + link.month + '.csv'
      }
    }, [_vm._v("Stáhnout CSV")])])]), _vm._v(" "), (_vm.is_this_month(link)) ? _c('small', [_c('br'), _vm._v("\n        platí k " + _vm._s(_vm.valid_as_of_formatted(link.fileValidAsOf)) + "\n      ")]) : _vm._e()])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f5f82c5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IpexCdrFilesLinks.vue
// module id = 309
// module chunks = 1 2